

































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
})
export default class extends Vue {
  @Provide()
  private scrollHeight = 500; //当前高度
  private GetAppData: any = {}; //当前应用号信息
  private AreaData: any = []; //省市区数据列表
  private AdvancedSettingsData: any = {
    //参与助力
    participate: {
      areaDisplay: false,
      area: [],
      genderDisplay: false,
      gender: 0
    },
    //领取海报
    receive: { areaDisplay: false, area: [], genderDisplay: false, gender: 0 },
    //防刷检测
    antiBrush: {
      Display: false,
      data: [
        {
          time: 3,
          unit: "second",
          people: 3
        },
        {
          time: 30,
          unit: "second",
          people: 30
        },
        {
          time: 1,
          unit: "hour",
          people: 90
        },
        {
          time: 1,
          unit: "day",
          people: 200
        }
      ]
    },
    //投诉预警
    complaint: { total: 10, openId: "" }
  };
  data() {
    return {
      props: {
        multiple: true,
        lazy: true,
        async lazyLoad(node: any, resolve: any) {
          //const { level } = node;
          // console.log(node);
          var that = this;
          let params: any = {
            Input: [
              {
                Name: "SuperiorCode",
                value: node.data.value
              }
            ]
          };
          var res: any = await httpApi.GetRegionInfoListAsync(params);
          //console.log(res);
          if (res.ErrorCode == 0) {
            //console.log(res.output[0].value);
            var nodes: any = [];
            res.output[0].value.forEach((e: any) => {
              let data = { value: e.Code, label: e.ShortName };
              // console.log(data);
              nodes.push(data);
            });
            resolve(nodes);
            //that.options = options;
          } else {
            // alert(res.ErrorMessage);
          }
        }
      }
    };
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    console.log(localStorage.getItem("PosterDataId"));

    this.loadtree();
    this.editData();
    Bus.$on("posterInfo", (Item: any) => {
      //this.BasicInformationData = Item;
      if (Item) {
      }
    });
    // this.editData();
  }

  //修改加载 数据
  async editData() {
    let id = localStorage.getItem("PosterDataId"); // getCookie("PosterId");
    console.log(id);
    
    if (id) {
      if (parseInt(id) > 0) {
        let params: any = {
          Input: [
            {
              Name: "PromotePosterListDTO",
              Value: {
                TenantId: this.GetAppData.TenantID,
                Aid: this.GetAppData.Aid,
                PosterId: id
              }
            }
          ]
        };
        var res: any = await httpApi.GetPosterModel(params);
        if (res.ErrorCode == 0) {
          let data = res.output[0].value;
          var ParticipateData = JSON.parse(data.Participate);
          this.loadListData(ParticipateData.area);
          this.AdvancedSettingsData.participate = ParticipateData;
          this.AdvancedSettingsData.receive = JSON.parse(data.Receive);
          this.AdvancedSettingsData.antiBrush = JSON.parse(data.AntiBrush);
          //console.log(this.AdvancedSettingsData.participate.area.length);

          console.log(this.AdvancedSettingsData.receive.area);
          this.refresh();
        } else {
          this.$message.error("加载修改数据失败：" + res.ErrorMessage);
        }
      }
    }
  }
  //加载列表数据
  async loadListData(item: any) {
    //this.AreaData
    if (item) {
      item.forEach(async (el: any) => {
        let data: any = [];
        let child: any = [];
        //console.log(el);
        for (var i = el.length - 1; i > -1; i--) {
          //console.log(el[i]);
          var res: any = await this.loadtreeItme(el[i]);
          //console.log(res);

          res.forEach((e: any) => {
            if (i == 0) {
              //最高级
              let temp = { value: e.Code, label: e.ShortName, children: child };
              data.push(temp);
            } else if (i == el.length - 1) {
              //最低级
              let temp = { value: e.Code, label: e.ShortName };
              child.push(temp);
            } else {
              //中间级
              let temp = { value: e.Code, label: e.ShortName, children: child };
              child.push(temp);
            }
          });
          if (i == 0) {
            console.log(el[i]);
            //
            var resData = this.AreaData.filter((item: any) => {
              return item.value.indexOf(el[i].trim()) >= 0;
            });
            console.log(resData);
            var newData = {
              value: resData[0].value,
              label: resData[0].label,
              children: data
            };
            // console.log(newData);
            this.AreaData.forEach((datat: any, index: number) => {
              if (datat.value == el[i]) {
                //console.log(index);
                this.AreaData.splice(index, 2, newData);
              }
            });
            // this.AreaData.splice(0, 2, resData, newData);
            console.log(this.AreaData);
          }
        }
        // el.forEach(async (data: any) => {
        //   console.log(data);
        //   var res: any = this.loadtreeItme(data);
        //   if (res) {
        //     console.log(res);
        //   }
        // });
      });
    }
  }
  async loadtree() {
    /*加载省级数据 */
    let paramsa: any = {
      Input: [
        {
          Name: "SuperiorCode",
          value: "000000"
        }
      ]
    };
    var res: any = await httpApi.GetRegionInfoListAsync(paramsa);
    // console.log(res);
    if (res.ErrorCode == 0) {
      this.AreaData = [];
      res.output[0].value.forEach((e: any) => {
        let data = { value: e.Code, label: e.ShortName };
        // console.log(data);
        this.AreaData.push(data);
      });
    } else {
      // alert(res.ErrorMessage);
    }
  }
  async loadtreeItme(value: string) {
    /*加载省级数据 */
    let paramsa: any = {
      Input: [
        {
          Name: "SuperiorCode",
          value: value
        }
      ]
    };
    var res: any = await httpApi.GetRegionInfoListAsync(paramsa);
    console.log(res);
    if (res.ErrorCode == 0) {
      return res.output[0].value;
    } else {
      // alert(res.ErrorMessage);
      return null;
    }
  }
  refresh() {
    Bus.$emit("AdvancedSettingsData", this.AdvancedSettingsData);
  }
}
